import cnContent from "./token/de/cn.js";
import usContent from "./token/de/us.js";
import jpContent from "./token/de/jp.js";
import koContent from "./token/de/ko.js";
import geContent from "./token/de/ge.js";
import ukContent from "./token/de/uk.js";
import uaeContent from "./token/de/uae.js";
import frContent from "./token/de/fr.js";
import sgContent from "./token/de/sg.js";

import agreementContent from "./agreement/de-de.js";

export default {
  "head.index": "Startseite",
  "head.product": "Produkte",
  "head.computeProduct": "Rechenleistungsprodukte",
  "head.computeProductDesc":
    "Rechenleistung kaufen und globale Renditen erzielen",
  "head.rentalProduct": "Mietprodukte",
  "head.rentalProductDesc": "Hochleistungsserver mieten für stabile Renditen",
  "head.rental": "Miete",
  "head.about": "Über uns",

  // ===== Benutzer-Dropdown-Menü =====
  "menu.profile": "Profil",
  "menu.security": "Kontosicherheit",
  "menu.settings": "Einstellungen",
  "menu.products": "Meine Produkte",
  "menu.deposits": "Einzahlungsverlauf",
  "menu.withdraws": "Auszahlungsverlauf",
  "menu.walletLog": "Transaktionsverlauf",
  "menu.logout": "Abmelden",
  "menu.logoutSuccess": "Erfolgreich abgemeldet",

  // ===== Fußzeile =====
  "footer.contactEmail": "Kontakt-E-Mail",

  // ===== Startseite =====
  "home.heroTitle1": "Globaler Neuer Rechenleistungs-Lord",
  "home.heroTitle2": "Dual-Antriebs-Vermögensmotor",
  "home.heroDesc":
    "Die Plattform priorisiert ausgereifte Standorte, die von KI-Giganten wie Microsoft, OpenAI und DeepSeek vorab für Leasing gesichert wurden",
  "home.heroBtn": "Jetzt Rechenleistungs-Renditen sichern →",
  "home.statTrade": "Tägliches Handelsvolumen",
  "home.statTradeValue": "1 Mrd.+",
  "home.statReliability": "Zuverlässigkeit",
  "home.statGlobal": "Globaler Service",
  "home.buildTitle1": "Bauen Sie Ihr",
  "home.buildTitle2": "Exklusives Rechenzentrum",
  "home.buildDesc1":
    "Unabhängige Verwaltung · Unabhängiges Leasing · Transparente Renditen — Wir kümmern uns nur um den Betrieb,",
  "home.buildDesc2": "Alle Renditen gehören dem Erbauer",
  "home.buildFeature1Title": "Unabhängige Verwaltung",
  "home.buildFeature1Desc":
    "Sie haben die volle Kontrolle über Ihr Rechenzentrum und entscheiden über Leasingstrategien und Preise",
  "home.buildFeature2Title": "Transparente Renditen",
  "home.buildFeature2Desc":
    "Echtzeit-Finanzdatenvisualisierung, jede Rendite ist klar nachvollziehbar",
  "home.buildFeature3Title": "Professioneller Betrieb",
  "home.buildFeature3Desc":
    "Wir übernehmen Hardware-Wartung, Netzwerk-Support und 7×24 technischen Support",
  "home.buildFeature4Title": "Alle Renditen gehören Ihnen",
  "home.buildFeature4Desc":
    "Nach Abzug der grundlegenden Betriebskosten gehören alle Leasingrenditen dem Erbauer",
  "home.buildBtn": "Jetzt bauen →",
  "home.buildStatsTitle": "📈 Bau-Renditen-Übersicht",
  "home.buildStatsUpdate": "Echtzeit-Update",
  "home.buildStatRooms": "Gebaute Rechenzentren",
  "home.buildStatServers": "Laufende Server",
  "home.buildStatProfit": "Gesamte Erbauer-Renditen",
  "home.buildStatPayback": "Durchschnittliche Amortisationszeit",
  "home.buildStatMonth": "Monate",
  "home.buildCta":
    "🎯 Jetzt beitreten und Ihr Recheninfrastruktur-Geschäft starten",
  "home.buildCtaBtn": "Mehr erfahren",
  "home.featuresBadge": "✦ Kernvorteile",
  "home.featuresTitle1": "Warum",
  "home.featuresTitle2": "AETRIVOL",
  "home.feature1Title": "Effizient & Bequem",
  "home.feature1Desc":
    "AETRIVOL nutzt seine Vorteile, um Einzelpersonen Zugang zu den Dividenden der Rechenleistungs-Ära zu verschaffen",
  "home.feature2Title": "Nationale Sicherheit",
  "home.feature2Desc":
    "Mehrschichtiger Netzwerkschutz, verschlüsselte Datenübertragung, 7×24 Sicherheitsüberwachung",
  "home.feature3Title": "Hochleistungs-Hardware",
  "home.feature3Desc":
    "NVIDIAs neueste GPU-Generation mit Hochgeschwindigkeits-NVMe-Speicher und DDR5-RAM",
  "home.feature4Title": "Globale Knoten",
  "home.feature4Desc":
    "Abdeckung von Rechenzentren in Asien-Pazifik, Europa und Nordamerika mit globaler Beschleunigung bei geringer Latenz",
  "home.appBadge": "📱 Mobil",
  "home.appTitle": "Bald verfügbar",
  "home.appDesc1": "AETRIVOL Mobile-App bald verfügbar,",
  "home.appDesc2":
    "Bleiben Sie jederzeit und überall über Rechenleistungs-Markttrends informiert,",
  "home.appDesc3": "Verwalten Sie Ihre GPU-Rechenleistung mit einem Klick.",
  "home.appQrText": "Zum Herunterladen scannen",
  "home.appStore": "App Store",
  "home.googlePlay": "Google Play",
  "home.walletsTitle1": "Partner",
  "home.walletsTitle2": "Wallets",
  "home.walletsDesc":
    "Verbinden Sie Ihre vertrauenswürdigen Wallets und verwalten Sie Vermögenswerte sicher",
  "home.settleTitle1": "Echtzeit",
  "home.settleTitle2": "Abrechnungs-Updates",
  "home.settleDesc": "Echtzeit-Renditeabrechnung für globale Nutzer",
  "home.modalTitle": "Bald verfügbar",
  "home.modalDesc1": "Derzeit keine neuen Rechenzentrumsprojekte verfügbar",
  "home.modalDesc2": "Vielen Dank für Ihre Aufmerksamkeit und Unterstützung!",
  "home.modalBtn": "Verstanden",

  // ===== Startseite - Rechenleistungsländer =====
  "tokenList.title1": "Wählen Sie Ihr",
  "tokenList.title2": "Rechenleistungsland",
  "tokenList.desc":
    "Weltweit führende Rechenleistungsländer, geringe Investition, hohe Renditen",
  "tokenList.buy": "Jetzt kaufen",
  "tokenList.more": "Weitere Produkte",
  "tokenList.tagHot": "🔥 Beliebt",
  "tokenList.tagProfit": "💰 Hohe Rendite",
  "tokenList.tagRecommend": "⭐ Empfohlen",
  "tokenList.tagNew": "🆕 Neu",

  // ===== Startseite - Serververmietung =====
  "serverList.title1": "Server",
  "serverList.title2": "Vermietung",
  "serverList.desc":
    "Ausgereifte Hochleistungsserver für überdurchschnittliche Mietrenditen",
  "serverList.dailyIncome": "Tägliches Einkommen",
  "serverList.value": "Serverwert",
  "serverList.yield": "Rendite",
  "serverList.gpu": "GPU",
  "serverList.vram": "VRAM",
  "serverList.storage": "Speicher",
  "serverList.status": "Status",
  "serverList.available": "✅ Verfügbar",
  "serverList.full": "⏳ Voll",
  "serverList.countdown": "Startet in",
  "serverList.over": "Endet in",
  "serverList.yunxz": "In Betrieb",
  "serverList.yunxzjs": "Endet in",
  "serverList.days": "Tagen",
  "serverList.btnFull": "Ausgebucht",
  "serverList.btnRent": "Jetzt mieten →",
  "serverList.btnWait": "Warten auf Start",
  "serverList.look": "Details ansehen",
  "serverList.btnEnded": "Beendet",
  "serverList.more": "Weitere Produkte ansehen",
  "serverList.spec1": "Einstieg",
  "serverList.spec2": "Leicht",
  "serverList.spec3": "Leistung",
  "serverList.spec4": "Flaggschiff",
  "serverList.tagHot": "🔥 Beliebt",
  "serverList.tagRecommend": "⭐ Empfohlen",
  "serverList.tagNew": "🌟 Neu",

  // ===== Startseite - Abrechnungs-Karussell =====
  "settle.amount": "Abrechnungsbetrag",
  "settle.status": "Abgerechnet",
  "settle.power": "Rechenleistungswert",
  "settle.rental": "Serververmietung",
  "settle.basic": "Grundrenditen",
  "settle.cycle": "Zyklusrenditen",
  "settle.phase1": "Phase 1",
  "settle.phase2": "Phase 2",
  "settle.phase3": "Phase 3",
  "settle.phase4": "Phase 4",

  // ===== Mitgliederzentrum =====
  "member.recharge": "Einzahlen",
  "member.withdraw": "Abheben",
  "member.tabProducts": "Meine Produkte",
  "member.tabHistory": "Verlauf",
  "member.tabWalletLog": "Wallet-Aufzeichnungen",
  "member.tabDeposits": "Einzahlungsverlauf",
  "member.tabWithdraws": "Auszahlungsverlauf",
  "member.tabAddresses": "Auszahlungsadressen",
  "member.avatarAlt": "Benutzeravatar",
  "member.settingsTitle": "Einstellungen",
  "member.logoutTitle": "Abmelden",
  "member.tabTokenProduct": "Rechenleistungsprodukte",
  "member.tabRentProduct": "Mietprodukte",

  // ===== Einstellungsseite =====
  "setting.back": "Zurück",
  "setting.title": "⚙️ Einstellungen",
  "setting.menuProfile": "Profil",
  "setting.menuSecurity": "Kontosicherheit",
  "setting.menuVerify": "Kontoverifizierung",
  "setting.menuChangePwd": "Passwort ändern",
  "setting.menuTradePwd": "Handelspasswort",
  "setting.getUserInfoFail":
    "Benutzerinformationen konnten nicht abgerufen werden",

  // ===== Einstellungen - Profil =====
  "profile.title": "Profil",
  "profile.subtitle": "Verwalten Sie Ihre grundlegenden Informationen",
  "profile.avatar": "Avatar",
  "profile.avatarAlt": "Avatar",
  "profile.changeAvatar": "Avatar ändern",
  "profile.systemAvatar": "System-Avatar",
  "profile.firstName": "Vorname",
  "profile.firstNamePlaceholder": "Vorname eingeben",
  "profile.lastName": "Nachname",
  "profile.lastNamePlaceholder": "Nachname eingeben",
  "profile.phone": "Telefon",
  "profile.phonePlaceholder": "Telefonnummer eingeben",
  "profile.address": "Adresse",
  "profile.addressPlaceholder": "Adresse eingeben",
  "profile.authUnverified": "Nicht verifiziert",
  "profile.gender": "Geschlecht",
  "profile.birthday": "Geburtsdatum",
  "profile.birthdayPlaceholder": "Geburtsdatum auswählen",
  "profile.country": "Land",
  "profile.countryPlaceholder": "Land auswählen",
  "profile.saving": "Speichern...",
  "profile.saveInfo": "Informationen speichern",
  "profile.selectSystemAvatar": "System-Avatar auswählen",
  "profile.avatarAltNum": "Avatar {count}",
  "profile.selectImageFile": "Bitte wählen Sie eine Bilddatei",
  "profile.imageTooLarge": "Bildgröße darf 5MB nicht überschreiten",
  "profile.uploadFail": "Upload fehlgeschlagen",
  "profile.updateFail": "Aktualisierung fehlgeschlagen",
  "profile.updateSuccess": "Aktualisierung erfolgreich",
  "profile.uploadFailNoPath": "Upload fehlgeschlagen, keine Bild-URL erhalten",
  "profile.uploadFailRetry":
    "Upload fehlgeschlagen, bitte später erneut versuchen",
  "profile.saveFail": "Speichern fehlgeschlagen",
  "profile.saveSuccess": "Speichern erfolgreich",
  "profile.saveFailRetry":
    "Speichern fehlgeschlagen, bitte später erneut versuchen",

  // ===== Einstellungen - Verifizierung =====
  "verifyPanel.title": "Kontoverifizierung",
  "verifyPanel.subtitle": "Erhöhen Sie Kontoberechtigungen und Vertrauensstufe",
  "verifyPanel.realName": "Echte-Namen-Verifizierung",
  "verifyPanel.realNameDesc":
    "Sie haben Ihre Echte-Namen-Verifizierungsinformationen eingereicht",
  "verifyPanel.verified": "Verifiziert ✓",
  "verifyPanel.goVerify": "Jetzt verifizieren →",

  // ===== Einstellungen - Kontosicherheit =====
  "securityPanel.title": "Kontosicherheit",
  "securityPanel.subtitle": "Schützen Sie Ihre Kontosicherheit",
  "securityPanel.phoneBind": "Telefonbindung",
  "securityPanel.phoneBound": "Gebunden {phone}",
  "securityPanel.notBound": "Nicht gebunden",
  "securityPanel.emailBind": "E-Mail-Bindung",
  "securityPanel.emailBound": "Gebunden {email}",
  "securityPanel.twofa": "Zwei-Faktor-Authentifizierung (2FA)",
  "securityPanel.twofaOn":
    "Aktiviert · Dynamischer Code bei jeder Anmeldung erforderlich",
  "securityPanel.twofaOff":
    "Deaktiviert · Empfohlen für erhöhte Sicherheit zu aktivieren",
  "securityPanel.twofaEnabled": "Aktiviert ✓",
  "securityPanel.enableTwofa": "2FA aktivieren",
  "securityPanel.disableTwofaTitle": "2FA deaktivieren",
  "securityPanel.enableTwofaTitle": "2FA aktivieren",
  "securityPanel.qrAlt": "2FA-QR-Code",
  "securityPanel.tip1":
    "1. Laden Sie Google Authenticator oder Microsoft Authenticator herunter",
  "securityPanel.tip2":
    "2. Scannen Sie den QR-Code oben oder geben Sie den geheimen Schlüssel ein",
  "securityPanel.copy": "Kopieren",
  "securityPanel.verifyCode": "Verifizierungscode",
  "securityPanel.verifyCodePlaceholder":
    "6-stelligen dynamischen Code eingeben",
  "securityPanel.emailCode": "E-Mail-Code",
  "securityPanel.emailCodePlaceholder": "E-Mail-Verifizierungscode eingeben",
  "securityPanel.resend": "Erneut in {count}s",
  "securityPanel.sendCode": "Code senden",
  "securityPanel.disableWarning1":
    "Nach der Deaktivierung von 2FA verliert Ihr Konto zusätzlichen Sicherheitsschutz.",
  "securityPanel.disableWarning2":
    "Bitte bestätigen Sie, dass Sie 2FA deaktivieren möchten.",
  "securityPanel.cancel": "Abbrechen",
  "securityPanel.confirmDisable": "Deaktivierung bestätigen",
  "securityPanel.confirmEnable": "Aktivierung bestätigen",
  "securityPanel.getSecretFail":
    "Geheimer Schlüssel konnte nicht abgerufen werden",
  "securityPanel.copySuccess": "Geheimer Schlüssel in Zwischenablage kopiert",
  "securityPanel.copyFail": "Geheimer Schlüssel konnte nicht kopiert werden",
  "securityPanel.enterVerifyCode":
    "Bitte 6-stelligen dynamischen Code eingeben",
  "securityPanel.operationFail": "Operation fehlgeschlagen",
  "securityPanel.twofaEnabledMsg": "2FA wurde aktiviert!",
  "securityPanel.twofaDisabledMsg": "2FA wurde deaktiviert!",
  "securityPanel.enterEmailCode": "Bitte E-Mail-Verifizierungscode eingeben",

  // ===== Einstellungen - Passwort ändern =====
  "changePwd.title": "Passwort ändern",
  "changePwd.subtitle":
    "Ändern Sie Ihr Passwort regelmäßig, um Ihr Konto zu schützen",
  "changePwd.warning":
    "Sie haben 2FA nicht aktiviert und können Ihr Passwort nicht ändern. Bitte aktivieren Sie zuerst 2FA.",
  "changePwd.goEnable": "Jetzt aktivieren",
  "changePwd.newPwd": "Neues Passwort",
  "changePwd.newPwdPlaceholder":
    "Neues Passwort eingeben (mindestens 6 Zeichen)",
  "changePwd.confirmPwd": "Neues Passwort bestätigen",
  "changePwd.confirmPwdPlaceholder": "Neues Passwort erneut eingeben",
  "changePwd.emailCode": "E-Mail-Code",
  "changePwd.emailCodePlaceholder": "E-Mail-Verifizierungscode eingeben",
  "changePwd.resend": "Erneut in {count}s",
  "changePwd.sendCode": "Code senden",
  "changePwd.confirmBtn": "Änderung bestätigen",
  "changePwd.twofaDesc":
    "Geben Sie Ihren 2FA-Code ein, um den E-Mail-Verifizierungscode zu senden",
  "changePwd.pwdTooShort": "Neues Passwort muss mindestens 6 Zeichen haben",
  "changePwd.pwdMismatch": "Die beiden neuen Passwörter stimmen nicht überein",
  "changePwd.enableTwofaFirst":
    "Bitte aktivieren Sie 2FA, bevor Sie Ihr Passwort ändern",
  "changePwd.codeError": "Verifizierungscode-Fehler",
  "changePwd.enterEmailCode": "Bitte E-Mail-Verifizierungscode eingeben",
  "changePwd.success":
    "Passwort erfolgreich geändert! Bitte melden Sie sich erneut an",

  // ===== Einstellungen - Handelspasswort =====
  "tradePwd.title": "Handelspasswort",
  "tradePwd.subtitle": "Schützen Sie Ihre Vermögenssicherheit",
  "tradePwd.warning":
    "Sie haben 2FA nicht aktiviert und können Ihr Handelspasswort nicht ändern. Bitte aktivieren Sie zuerst 2FA.",
  "tradePwd.goEnable": "Jetzt aktivieren",
  "tradePwd.newPwd": "Neues Handelspasswort",
  "tradePwd.newPwdPlaceholder":
    "Neues Handelspasswort eingeben (mindestens 6 Zeichen)",
  "tradePwd.confirmPwd": "Handelspasswort bestätigen",
  "tradePwd.confirmPwdPlaceholder": "Neues Handelspasswort erneut eingeben",
  "tradePwd.emailCode": "E-Mail-Code",
  "tradePwd.emailCodePlaceholder": "E-Mail-Verifizierungscode eingeben",
  "tradePwd.resend": "Erneut in {count}s",
  "tradePwd.sendCode": "Code senden",
  "tradePwd.confirmBtn": "Änderung bestätigen",
  "tradePwd.twofaDesc":
    "Geben Sie Ihren 2FA-Code ein, um den E-Mail-Verifizierungscode zu senden",
  "tradePwd.pwdTooShort":
    "Neues Handelspasswort muss mindestens 6 Zeichen haben",
  "tradePwd.pwdMismatch": "Die beiden Handelspasswörter stimmen nicht überein",
  "tradePwd.enableTwofaFirst":
    "Bitte aktivieren Sie 2FA, bevor Sie Ihr Handelspasswort ändern",
  "tradePwd.codeError": "Verifizierungscode-Fehler",
  "tradePwd.enterEmailCode": "Bitte E-Mail-Verifizierungscode eingeben",
  "tradePwd.success": "Handelspasswort erfolgreich geändert!",

  // ===== Mitgliederzentrum - Verlauf =====
  "history.tabToken": "Rechenleistungsaufzeichnungen",
  "history.tabRent": "Mietaufzeichnungen",

  // ===== Mitgliederzentrum - Rechenleistungsverlauf =====
  "historyToken.type": "Typ",
  "historyToken.allType": "Alle Typen",
  "historyToken.buy": "Kauf",
  "historyToken.income": "Einkommen",
  "historyToken.reset": "Zurücksetzen",
  "historyToken.loading": "Laden...",
  "historyToken.empty": "Keine Produkte",
  "historyToken.date": "Datum",
  "historyToken.product": "Produkt",
  "historyToken.quantity": "Menge",
  "historyToken.amount": "Betrag",
  "historyToken.fee": "Gebühr",
  "historyToken.total": "Gesamt",
  "historyToken.time": "Zeit",
  "historyToken.profit": "Gewinn/Verlust",
  "historyToken.deduct": "Abzug",
  "historyToken.profitPositive": "Gewinn",
  "historyToken.profitNegative": "Verlust",
  "historyToken.unknownStatus": "Unbekannter Status",
  "historyToken.paginationInfo":
    "Insgesamt {total} Einträge, Seite {page} / {totalPages}",
  "historyToken.firstPage": "Erste",
  "historyToken.prevPage": "Zurück",
  "historyToken.nextPage": "Weiter",
  "historyToken.lastPage": "Letzte",
  "historyToken.perPage": "{count}/Seite",

  // ===== Mitgliederzentrum - Mietverlauf =====
  "historyServer.type": "Typ",
  "historyServer.allType": "Alle Typen",
  "historyServer.buy": "Kauf",
  "historyServer.income": "Einkommen",
  "historyServer.reset": "Zurücksetzen",
  "historyServer.loading": "Laden...",
  "historyServer.empty": "Keine Produkte",
  "historyServer.date": "Datum",
  "historyServer.product": "Produkt",
  "historyServer.share": "Anteil",
  "historyServer.amount": "Betrag",
  "historyServer.fee": "Gebühr",
  "historyServer.total": "Gesamt",
  "historyServer.time": "Zeit",
  "historyServer.unknownStatus": "Unbekannter Status",
  "historyServer.paginationInfo":
    "Insgesamt {total} Einträge, Seite {page} / {totalPages}",
  "historyServer.firstPage": "Erste",
  "historyServer.prevPage": "Zurück",
  "historyServer.nextPage": "Weiter",
  "historyServer.lastPage": "Letzte",
  "historyServer.perPage": "{count}/Seite",

  // ===== Mitgliederzentrum - Einzahlungsverlauf =====
  "deposit.loading": "Laden...",
  "deposit.empty": "Keine Einzahlungsaufzeichnungen",
  "deposit.coin": "Münze",
  "deposit.quantity": "Menge",
  "deposit.network": "Netzwerk",
  "deposit.address": "Adresse",
  "deposit.status": "Status",
  "deposit.time": "Zeit",
  "deposit.success": "Erfolgreich",
  "deposit.processing": "Verarbeitung",
  "deposit.paginationInfo":
    "Insgesamt {total} Einträge, Seite {page} / {totalPages}",
  "deposit.firstPage": "Erste",
  "deposit.prevPage": "Zurück",
  "deposit.nextPage": "Weiter",
  "deposit.lastPage": "Letzte",
  "deposit.perPage": "{count}/Seite",

  // ===== Mitgliederzentrum - Auszahlungsverlauf =====
  "withdrawal.loading": "Laden...",
  "withdrawal.empty": "Keine Auszahlungsaufzeichnungen",
  "withdrawal.coin": "Münze",
  "withdrawal.quantity": "Menge",
  "withdrawal.network": "Netzwerk",
  "withdrawal.address": "Adresse",
  "withdrawal.status": "Status",
  "withdrawal.time": "Zeit",
  "withdrawal.statusProcessing": "Verarbeitung",
  "withdrawal.statusSuccess": "Erfolgreich",
  "withdrawal.statusFailed": "Fehlgeschlagen",
  "withdrawal.statusUnknown": "Unbekannt",
  "withdrawal.paginationInfo":
    "Insgesamt {total} Einträge, Seite {page} / {totalPages}",
  "withdrawal.firstPage": "Erste",
  "withdrawal.prevPage": "Zurück",
  "withdrawal.nextPage": "Weiter",
  "withdrawal.lastPage": "Letzte",
  "withdrawal.perPage": "{count}/Seite",

  // ===== Mitgliederzentrum - Auszahlungsadressen =====
  "addresse.title": "Auszahlungsadressen",
  "addresse.addAddress": "+ Adresse hinzufügen",
  "addresse.loading": "Laden...",
  "addresse.empty": "Keine Auszahlungsadressen",
  "addresse.coin": "Münze",
  "addresse.network": "Netzwerk",
  "addresse.address": "Adresse",
  "addresse.time": "Zeit",
  "addresse.action": "Aktion",
  "addresse.delete": "Löschen",
  "addresse.deleteConfirm":
    "Möchten Sie diese Auszahlungsadresse wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
  "addresse.cancel": "Abbrechen",
  "addresse.confirmDelete": "Löschen bestätigen",
  "addresse.deleteSuccess": "Erfolgreich gelöscht",
  "addresse.paginationInfo":
    "Insgesamt {total} Einträge, Seite {page} / {totalPages}",
  "addresse.firstPage": "Erste",
  "addresse.prevPage": "Zurück",
  "addresse.nextPage": "Weiter",
  "addresse.lastPage": "Letzte",
  "addresse.perPage": "{count}/Seite",

  // ===== Mitgliederzentrum - Wallet-Aufzeichnungen =====
  "walletLog.type": "Typ",
  "walletLog.allType": "Alle Typen",
  "walletLog.reset": "Zurücksetzen",
  "walletLog.loading": "Laden...",
  "walletLog.empty": "Keine Produkte",
  "walletLog.project": "Projekt",
  "walletLog.amount": "Betrag",
  "walletLog.time": "Zeit",
  "walletLog.day": "Tagen",
  "walletLog.paginationInfo":
    "Insgesamt {total} Einträge, Seite {page} / {totalPages}",
  "walletLog.firstPage": "Erste",
  "walletLog.prevPage": "Zurück",
  "walletLog.nextPage": "Weiter",
  "walletLog.lastPage": "Letzte",
  "walletLog.perPage": "{count}/Seite",
  "walletLog.typeDeposit": "Einzahlung",
  "walletLog.typeWithdraw": "Auszahlung",
  "walletLog.typePay": "Zahlung",
  "walletLog.typeTokenIncome": "Rechenleistungsgewinn",
  "walletLog.typeTokenLoss": "Rechenleistungsverlust",
  "walletLog.typeServerIncome": "Server-Einkommen",
  "walletLog.typeTransferReturn": "Auszahlungsrückgabe",
  "walletLog.typeFreezeBuy": "(Kauf) Eingefroren",
  "walletLog.typeServerRent": "Server-Miete",
  "walletLog.typeUnfreeze": "(Abgelaufen) Aufgetaut",
  "walletLog.typeCompute": "Rechenleistung",
  "walletLog.typeRent": "Miete",
  "walletLog.statusUnknown": "Unbekannter Status",
  "walletLog.titlePower": "Rechenleistung",
  "walletLog.titleRent": "Miete",
  "walletLog.statusDeposit": "Einzahlung",
  "walletLog.statusWithdrawal": "Auszahlung",
  "walletLog.statusPay": "Zahlung",
  "walletLog.statusPowerProfit": "Rechenleistungsgewinn",
  "walletLog.statusPowerLoss": "Rechenleistungsverlust",
  "walletLog.statusServerIncome": "Server-Einkommen",
  "walletLog.statusWithdrawalReturn": "Auszahlungsrückgabe",
  "walletLog.statusPurchaseFreeze": "(Kauf) Eingefroren",
  "walletLog.statusServerRent": "Server-Miete",
  "walletLog.statusExpireUnfreeze": "(Abgelaufen) Aufgetaut",

  // ===== Mitgliederzentrum - Vermögensübersicht =====
  "memberBox.assetOverview": "Vermögensübersicht",
  "memberBox.realTime": "Echtzeit-Update",
  "memberBox.totalAssets": "Gesamtvermögen",
  "memberBox.vsYesterday": "vs. Gestern",
  "memberBox.availableBalance": "Verfügbares Guthaben",
  "memberBox.frozenFunds": "Eingefrorene Mittel",
  "memberBox.incomeTrend": "Einkommenstrend",
  "memberBox.hashIncome": "Rechenleistungseinkommen",
  "memberBox.leaseIncome": "Mieteinkommen",
  "memberBox.hashIncomeTotal": "Gesamtes Rechenleistungseinkommen",
  "memberBox.leaseIncomeTotal": "Gesamtes Mieteinkommen",
  "memberBox.totalIncome": "Gesamteinkommen",
  "memberBox.vsLastDay": "vs. Letzter Tag",
  "memberBox.time7d": "7T",
  "memberBox.time15d": "15T",
  "memberBox.time30d": "30T",

  // ===== Mitgliederzentrum - Produktliste =====
  "productToken.region": "Region",
  "productToken.allRegion": "Alle Regionen",
  "productToken.status": "Status",
  "productToken.allStatus": "Alle Status",
  "productToken.statusActive": "Aktiv",
  "productToken.statusCompleted": "Abgeschlossen",
  "productToken.statusFrozen": "Eingefroren",
  "productToken.statusUnknown": "Unbekannter Status",
  "productToken.reset": "Zurücksetzen",
  "productToken.loading": "Laden...",
  "productToken.empty": "Keine Produkte",
  "productToken.quantity": "Menge",
  "productToken.period": "Zeitraum",
  "productToken.latestProfit": "Letzter G/V",
  "productToken.settledProfit": "Abgerechneter G/V",
  "productToken.periodProfit": "Zeitraum-G/V",
  "productToken.totalProfit": "Gesamt-G/V",
  "productToken.action": "Aktion",
  "productToken.view": "Ansehen",
  "productToken.day": "Tagen",
  "productToken.paginationInfo":
    "Insgesamt {total} Einträge, Seite {page} / {totalPages}",
  "productToken.firstPage": "Erste",
  "productToken.prevPage": "Zurück",
  "productToken.nextPage": "Weiter",
  "productToken.lastPage": "Letzte",
  "productToken.perPage": "{count}/Seite",
  "productToken.detailTitle": "Produktdetails",
  "productToken.productCode": "Produktcode",
  "productToken.orderCode": "Bestellnummer",
  "productToken.orderName": "Produktname",
  "productToken.tradeInfo": "Handelsinfo",
  "productToken.tradeTime": "Handelszeit",
  "productToken.buyPrice": "Kaufpreis",
  "productToken.principal": "Kapital",
  "productToken.fee": "Gebühr",
  "productToken.latestPrice": "Aktueller Preis",
  "productToken.profitInfo": "G/V-Info",
  "productToken.estimatedProfit": "Geschätzter Gesamt-G/V",
  "productToken.remark": "Bemerkung",
  "productToken.close": "Schließen",

  // ===== Mitgliederzentrum - Server-Produktliste =====
  "productServer.region": "Region",
  "productServer.allRegion": "Alle Regionen",
  "productServer.status": "Status",
  "productServer.allStatus": "Alle Status",
  "productServer.statusActive": "Aktiv",
  "productServer.statusCompleted": "Abgeschlossen",
  "productServer.statusFrozen": "Eingefroren",
  "productServer.statusUnknown": "Unbekannter Status",
  "productServer.reset": "Zurücksetzen",
  "productServer.loading": "Laden...",
  "productServer.empty": "Keine Produkte",
  "productServer.productName": "Produktname",
  "productServer.share": "Anteil",
  "productServer.countdown": "Countdown",
  "productServer.unsettledIncome": "Unverr. Ertrag",
  "productServer.settled": "Abgerechnet",
  "productServer.totalIncome": "Gesamteinkommen",
  "productServer.action": "Aktion",
  "productServer.view": "Ansehen",
  "productServer.day": "Tagen",
  "productServer.paginationInfo":
    "Insgesamt {total} Einträge, Seite {page} / {totalPages}",
  "productServer.firstPage": "Erste",
  "productServer.prevPage": "Zurück",
  "productServer.nextPage": "Weiter",
  "productServer.lastPage": "Letzte",
  "productServer.perPage": "{count}/Seite",
  "productServer.detailTitle": "Produktdetails",
  "productServer.productCode": "Produktcode",
  "productServer.orderCode": "Bestellnummer",
  "productServer.orderName": "Produktname",
  "productServer.leaseInfo": "Leasing-Info",
  "productServer.leaseDate": "Leasingdatum",
  "productServer.rent": "Miete",
  "productServer.maintenanceFee": "Wartungsgebühr",
  "productServer.profitInfo": "Einkommensinfo",
  "productServer.estimatedLeaseIncome": "Geschätztes Gesamt-Leasingeinkommen",
  "productServer.settledIncome": "Abgerechnetes Einkommen",
  "productServer.phase": "{count} Phase",
  "productServer.phaseList": "Phaseneinnahmen",
  "productServer.currentPhase": "Aktuelle Phase",
  "productServer.remark": "Bemerkung",
  "productServer.close": "Schließen",

  // ===== Registrierung / Qualifikationsantrag =====
  "register.back": "Zurück zur Anmeldung",
  "register.statusBadge": "Qualifikationsantrag · Manuelle Prüfung",
  "register.title": "Qualifikation beantragen",
  "register.subtitle":
    "Nach dem Absenden Ihrer Informationen schließen wir die Prüfung innerhalb von 24 Stunden ab und benachrichtigen Sie per E-Mail",
  "register.basicInfo": "Grundinformationen",
  "register.firstNamePlaceholder": "Vorname eingeben",
  "register.lastNamePlaceholder": "Nachname eingeben",
  "register.genderMale": "Männlich",
  "register.genderFemale": "Weiblich",
  "register.genderSecret": "Keine Angabe",
  "register.birthdayPlaceholder": "Geburtsdatum auswählen",
  "register.maritalStatus": "Familienstand",
  "register.maritalUnmarried": "Ledig",
  "register.maritalMarried": "Verheiratet",
  "register.maritalDivorced": "Geschieden",
  "register.maritalWidowed": "Verwitwet",
  "register.contactAddress": "Kontaktadresse",
  "register.addressPlaceholder": "Kontaktadresse eingeben",
  "register.occupationInfo": "Berufsinformationen",
  "register.workUnitPlaceholder": "Arbeitsstätte eingeben",
  "register.workAddressPlaceholder": "Arbeitsadresse eingeben",
  "register.occupationPlaceholder": "Beruf eingeben",
  "register.incomePlaceholder": "Jahreseinkommensbereich auswählen",
  "register.incomeBelow5": "Unter 50K",
  "register.income5to10": "50K - 100K",
  "register.income10to20": "100K - 200K",
  "register.income20to50": "200K - 500K",
  "register.income50to100": "500K - 1M",
  "register.incomeAbove100": "Über 1M",
  "register.otherInfo": "Weitere Informationen",
  "register.remarksPlaceholder":
    "Zusätzliche Anmerkungen (optional, z.B. Bewerbungsgrund, besondere Anforderungen)",
  "register.accountInfo": "Kontoinformationen",
  "register.inviteCodePlaceholder": "Verifizierungscode eingeben",
  "register.emailPlaceholder":
    "E-Mail-Adresse eingeben (Prüfungsergebnis wird an diese E-Mail gesendet)",
  "register.verifyCodePlaceholder": "E-Mail-Verifizierungscode eingeben",
  "register.agreementText":
    "Ich bestätige, dass die oben genannten Informationen wahr und gültig sind, und stimme der",
  "register.agreementLink": "Nutzungsvereinbarung",
  "register.auditNotice1":
    "Nach dem Absenden führen wir eine manuelle Prüfung durch",
  "register.auditNotice2": "innerhalb von 24 Stunden",
  "register.auditNotice3":
    " und benachrichtigen Sie per E-Mail. Bitte stellen Sie sicher, dass Ihre E-Mail-Adresse korrekt ist.",
  "register.submitBtn": "Antrag einreichen",
  "register.submitting": "Wird gesendet...",
  "register.hasAccount": "Haben Sie bereits ein Konto?",
  "register.gotoLogin": "Anmelden",
  "register.successTitle": "Erfolgreich eingereicht!",
  "register.successDesc1":
    "Ihr Qualifikationsantrag wurde empfangen. Wir schließen die Prüfung innerhalb von",
  "register.successDesc2": "24 Stunden",
  "register.successDesc3": " ab.",
  "register.successDesc4": "Das Prüfungsergebnis wird gesendet an:",
  "register.successTip":
    "Bitte überprüfen Sie Ihre E-Mail. Vielen Dank für Ihre Bewerbung!",
  "register.modalBtn": "Verstanden",
  "register.sending": "Wird gesendet",
  "register.resendSuffix": "zum erneuten Senden",
  "register.auditNoticeMid":
    ", das Prüfungsergebnis wird gesendet innerhalb von",
  "register.invalidEmail": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
  "register.codeSent":
    "Verifizierungscode wurde an Ihre E-Mail gesendet, bitte überprüfen",
  "register.inviteCodeInvalid":
    "Bitte geben Sie einen 6-stelligen Einladungscode ein",
  "register.verifyCodeInvalid":
    "Bitte geben Sie einen 4-stelligen E-Mail-Verifizierungscode ein",
  "register.firstNameRequired": "Bitte geben Sie Ihren echten Vornamen ein",
  "register.lastNameRequired": "Bitte geben Sie Ihren echten Nachnamen ein",
  "register.genderRequired": "Bitte wählen Sie Ihr Geschlecht",
  "register.birthdayRequired": "Bitte wählen Sie Ihr Geburtsdatum",
  "register.maritalRequired": "Bitte wählen Sie Ihren Familienstand",
  "register.addressRequired": "Bitte geben Sie Ihre Adresse ein",
  "register.workUnitRequired": "Bitte geben Sie Ihre Arbeitsstätte ein",
  "register.workAddressRequired": "Bitte geben Sie Ihre Arbeitsadresse ein",
  "register.occupationRequired": "Bitte geben Sie Ihren Beruf ein",
  "register.incomeRequired": "Bitte wählen Sie Ihren Jahreseinkommensbereich",
  "register.agreeRequired":
    "Bitte lesen und akzeptieren Sie die Qualifikationsprüfungsbedingungen und Datenschutzrichtlinie",
  "register.registerFail": "Registrierung fehlgeschlagen",
  "register.submitFail":
    "Übermittlung fehlgeschlagen, bitte später erneut versuchen",

  // ===== Anmeldeseite =====
  "login.title": "AI Compute Cloud",
  "login.subtitle": "KI-Rechenleistungs-Cloud",
  "login.usernamePlaceholder": "Kontonamen eingeben",
  "login.passwordPlaceholder": "Kontopasswort eingeben",
  "login.forgotPassword": "Passwort vergessen",
  "login.loginBtn": "Anmelden",
  "login.noQualification": "Noch keine Qualifikation?",
  "login.applyNow": "Jetzt beantragen",
  "login.loginSuccess": "Anmeldung erfolgreich",
  "login.enterCredentials": "Bitte geben Sie Konto und Passwort ein",
  "login.loading": "Laden...",

  // ===== Passwort zurücksetzen =====
  "reset.back": "Zurück zur Anmeldung",
  "reset.title": "Passwort zurücksetzen",
  "reset.subtitleStep1":
    "Identität verifizieren und Kontopasswort zurücksetzen",
  "reset.subtitleStep2":
    "Neues Passwort festlegen, um die Kontosicherheit zu gewährleisten",
  "reset.emailPlaceholder": "Registrierte E-Mail-Adresse eingeben",
  "reset.captchaPlaceholder": "Verifizierungscode eingeben",
  "reset.sending": "Wird gesendet",
  "reset.getCaptcha": "Code erhalten",
  "reset.nextStep": "Nächster Schritt",
  "reset.newPasswordPlaceholder":
    "Neues Passwort festlegen (mindestens 6 Zeichen)",
  "reset.confirmPasswordPlaceholder": "Neues Passwort erneut eingeben",
  "reset.resetBtn": "Jetzt zurücksetzen",
  "reset.rememberPassword": "Passwort merken?",
  "reset.gotoLogin": "Anmelden",
  "reset.invalidEmail": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
  "reset.captchaSent": "Verifizierungscode erfolgreich gesendet",
  "reset.captchaInvalid":
    "Bitte geben Sie einen gültigen Verifizierungscode ein (mindestens 4 Zeichen)",
  "reset.passwordTooShort": "Neues Passwort muss mindestens 6 Zeichen haben",
  "reset.passwordMismatch": "Die beiden Passwörter stimmen nicht überein",
  "reset.resetSuccess":
    "Passwort erfolgreich zurückgesetzt! Bitte melden Sie sich erneut an",

  // ===== Identitätsverifizierungsseite =====
  "verify.statusBadge": "Identitätsverifizierung · Informationsformular",
  "verify.title": "Kontoverifizierung",
  "verify.subtitle":
    "Bitte geben Sie Ihre echten Identitätsinformationen ein. Nach dem Absenden wird eine manuelle Prüfung durchgeführt",
  "verify.accountSecurity": "Kontosicherheit",
  "verify.loginPassword": "Anmeldepasswort",
  "verify.confirmLoginPassword": "Anmeldepasswort bestätigen",
  "verify.tradePassword": "Handelspasswort",
  "verify.confirmTradePassword": "Handelspasswort bestätigen",
  "verify.securityQuestion": "Sicherheitsfrage",
  "verify.securityAnswer": "Sicherheitsantwort",
  "verify.basicInfo": "Grundinformationen",
  "verify.country": "Land",
  "verify.countryPlaceholder": "Land auswählen",
  "verify.phone": "Telefonnummer",
  "verify.realName": "Echter Name",
  "verify.idNumber": "Ausweisnummer",
  "verify.idPhoto": "Ausweisfoto",
  "verify.frontPhoto": "Vorderseite",
  "verify.backPhoto": "Rückseite",
  "verify.handPhoto": "Ausweis in der Hand",
  "verify.uploading": "Wird hochgeladen...",
  "verify.clickUpload": "Zum Hochladen klicken",
  "verify.uploadHint": "Unterstützt JPG / PNG, empfohlen innerhalb von 5MB",
  "verify.uploadHandHint":
    "Bitte halten Sie Ihren Ausweis beim Fotografieren, sodass Gesicht und Ausweisinformationen deutlich sichtbar sind",
  "verify.reupload": "Erneut hochladen",
  "verify.auditNotice1":
    "Nach dem Absenden wird eine manuelle Prüfung durchgeführt",
  "verify.auditNoticeMid": ", das Prüfungsergebnis wird gesendet innerhalb von",
  "verify.auditNotice2": "24 Stunden",
  "verify.auditNotice3":
    ". Bitte stellen Sie sicher, dass Ihre Informationen korrekt sind.",
  "verify.submitBtn": "Verifizierung einreichen",
  "verify.submitting": "Wird gesendet...",
  "verify.hasAccount": "Haben Sie bereits ein Konto?",
  "verify.gotoLogin": "Anmelden",
  "verify.successTitle": "Erfolgreich eingereicht!",
  "verify.successDesc1":
    "Ihre Verifizierungsinformationen wurden eingereicht. Wir schließen die Prüfung innerhalb von",
  "verify.successDesc2": "24 Stunden",
  "verify.successDesc3": " ab.",
  "verify.successDesc4": "Das Prüfungsergebnis wird Ihnen per SMS zugesendet.",
  "verify.successTip":
    "Bitte halten Sie Ihr Telefon bereit. Vielen Dank für Ihre Kooperation!",
  "verify.modalBtn": "Verstanden",
  "verify.loginPasswordPlaceholder":
    "Anmeldepasswort festlegen (mindestens 6 Zeichen)",
  "verify.confirmLoginPasswordPlaceholder": "Anmeldepasswort erneut eingeben",
  "verify.tradePasswordPlaceholder":
    "Handelspasswort festlegen (mindestens 6 Zeichen)",
  "verify.confirmTradePasswordPlaceholder": "Handelspasswort erneut eingeben",
  "verify.securityQuestionPlaceholder": "Sicherheitsfrage eingeben",
  "verify.securityAnswerPlaceholder": "Sicherheitsantwort eingeben",
  "verify.phonePlaceholder": "Telefonnummer eingeben",
  "verify.realNamePlaceholder":
    "Echten Namen eingeben (muss mit Ausweis übereinstimmen)",
  "verify.idNumberPlaceholder": "Ausweisnummer eingeben",
  "verify.uploadImage": "Bitte laden Sie eine Bilddatei hoch",
  "verify.imageTooLarge": "Bildgröße darf 5MB nicht überschreiten",
  "verify.uploadSuccess": "Bild erfolgreich hochgeladen",
  "verify.uploadFail": "Bild-Upload fehlgeschlagen",
  "verify.uploadFailRetry":
    "Bild-Upload fehlgeschlagen, bitte später erneut versuchen",
  "verify.passwordTooShort": "Passwort muss mindestens 6 Zeichen haben",
  "verify.confirmPasswordRequired": "Bitte geben Sie das Passwort erneut ein",
  "verify.passwordMismatch": "Die beiden Passwörter stimmen nicht überein",
  "verify.tradePasswordTooShort":
    "Handelspasswort muss mindestens 6 Zeichen haben",
  "verify.confirmTradePasswordRequired":
    "Bitte geben Sie das Handelspasswort erneut ein",
  "verify.tradePasswordMismatch":
    "Die beiden Handelspasswörter stimmen nicht überein",
  "verify.securityQuestionRequired":
    "Bitte geben Sie eine Sicherheitsfrage ein",
  "verify.countryRequired": "Bitte wählen Sie Ihr Land",
  "verify.phoneInvalid": "Bitte geben Sie eine gültige Telefonnummer ein",
  "verify.realNameRequired":
    "Bitte geben Sie Ihren echten Namen ein (mindestens 2 Zeichen)",
  "verify.idNumberInvalid": "Bitte geben Sie eine gültige Ausweisnummer ein",
  "verify.idFrontRequired":
    "Bitte laden Sie die Vorderseite Ihres Ausweises hoch",
  "verify.idBackRequired": "Bitte laden Sie die Rückseite Ihres Ausweises hoch",
  "verify.idHandRequired":
    "Bitte laden Sie ein Foto mit Ausweis in der Hand hoch",
  "verify.submitSuccess": "Erfolgreich eingereicht",
  "verify.submitFail": "Übermittlung fehlgeschlagen",
  "verify.submitFailRetry":
    "Übermittlung fehlgeschlagen, bitte später erneut versuchen",

  // ===== Mietliste =====
  "rental.title1": "Server",
  "rental.title2": "Vermietung",
  "rental.desc":
    "Kuratierte Hochleistungsserver zur Investition in Ihre persönlichen Rechenleistungs-Assets und zur Unterstützung der globalen Rechenleistungsentwicklung",
  "rental.statServers": "Mietbare Server",
  "rental.statAvailability": "Verfügbarkeit",
  "rental.statSupport": "Kundensupport",
  "rental.searchPlaceholder": "Servername, GPU-Modell suchen...",
  "rental.filterAll": "Alle",
  "rental.filterHot": "🔥 Beliebt",
  "rental.filterRecommend": "⭐ Empfohlen",
  "rental.filterNew": "🌟 Neu",
  "rental.sortDefault": "Standard-Sortierung",
  "rental.sortRemainingAsc": "Verbleibend ↑",
  "rental.sortRemainingDesc": "Verbleibend ↓",
  "rental.sortValueAsc": "Gesamtwert ↑",
  "rental.sortValueDesc": "Gesamtwert ↓",
  "rental.sortIncomeAsc": "Tageseinkommen ↑",
  "rental.sortIncomeDesc": "Tageseinkommen ↓",
  "rental.sortStartAsc": "Startdatum ↑",
  "rental.sortStartDesc": "Startdatum ↓",
  "rental.sortEndAsc": "Enddatum ↑",
  "rental.sortEndDesc": "Enddatum ↓",
  "rental.resultCount": "{count} Server insgesamt",
  "rental.loading": "Laden...",
  "rental.empty": "Keine passenden Server gefunden",
  "rental.totalValue": "Gesamtwert",
  "rental.country": "Land",
  "rental.incomeTrend": "Einkommenstrend",
  "rental.activityPeriod": "📅 Zeitraum",
  "rental.remaining": "⏳ Verbleibend",
  "rental.days": "Tagen",
  "rental.memory": "Speicher",
  "rental.storage": "Speicher",
  "rental.bandwidth": "Bandbreite",
  "rental.status": "Status",
  "rental.available": "✅ Verfügbar",
  "rental.full": "⏳ Voll",
  "rental.countdown": "Startet in",
  "rental.btnFull": "Ausgebucht",
  "rental.btnRent": "Jetzt mieten",
  "rental.btnWait": "Warten auf Start",
  "rental.btnEnded": "Beendet",
  "rental.btnRentList": "Mieten",
  "rental.btnNotStart": "Nicht gestartet",
  "rental.NotRent": "Nicht mietbar",
  "rental.value": "Wert",
  "rental.prev": "← Zurück",
  "rental.next": "Weiter →",
  "rental.perPage": "{count} / Seite",
  "rental.processBadge": "📋 Mietprozess",
  "rental.processTitle1": "Server mieten",
  "rental.processTitle2": "in 3 einfachen Schritten",
  "rental.step1Icon": "🔍",
  "rental.step1Title": "Server auswählen",
  "rental.step1Desc":
    "Durchsuchen Sie die Serverliste und wählen Sie die passende Konfiguration für Ihre Anforderungen",
  "rental.step2Icon": "📝",
  "rental.step2Title": "Mietantrag einreichen",
  "rental.step2Desc":
    "Mietdauer, Zweck und andere Informationen ausfüllen, dann zur Prüfung einreichen",
  "rental.step3Icon": "🚀",
  "rental.step3Title": "Bereitstellen & Nutzen",
  "rental.step3Desc":
    "Nach Genehmigung sofort bereitstellen und Ihre KI-Rechenleistungsreise starten",
  "rental.ctaTitle": "Den richtigen Server nicht gefunden?",
  "rental.ctaDesc":
    "Kontaktieren Sie uns für eine maßgeschneiderte Lösung. Unser professionelles Team empfiehlt die optimale Konfiguration",
  "rental.ctaContact": "Support kontaktieren",
  "rental.ctaFaq": "FAQ ansehen",
  "rental.spec1": "Einstieg",
  "rental.spec2": "Leicht",
  "rental.spec3": "Leistung",
  "rental.spec4": "Flaggschiff",
  "rental.tagHot": "🔥 Beliebt",
  "rental.tagRecommend": "⭐ Empfohlen",
  "rental.tagNew": "🌟 Neu",
  "rental.statusActive": "Aktiv",
  "rental.statusPending": "Nicht gestartet",
  "rental.statusEnded": "Beendet",
  "rental.income": "Einkommen",
  "rental.progress": "Fortschritt",
  "rental.countryAlt": "Land",
  "rental.monday": "Mo",
  "rental.tuesday": "Di",
  "rental.wednesday": "Mi",
  "rental.thursday": "Do",
  "rental.friday": "Fr",
  "rental.saturday": "Sa",
  "rental.sunday": "So",

  // ===== Auszahlungsseite =====
  "withdraw.title": "💸 Konto-Auszahlung",
  "withdraw.desc": "Schnelle Auszahlung, sichere Ankunft",
  "withdraw.balance": "Verfügbares Guthaben",
  "withdraw.methodCrypto": "🪙 Kryptowährung",
  "withdraw.methodBank": "🏦 Bank-Auszahlung",
  "withdraw.selectCoin": "Münze auswählen",
  "withdraw.selectNetwork": "Netzwerk auswählen",
  "withdraw.address": "Auszahlungsadresse",
  "withdraw.bindAddress": "➕ Adresse binden",
  "withdraw.selectAddress": "Auszahlungsadresse auswählen",
  "withdraw.noAddress": "Keine verfügbaren Adressen",
  "withdraw.noAddressTip": "⚠️ Keine gebundene {coin}-Adresse. Bitte",
  "withdraw.bindLink": "eine Adresse binden",
  "withdraw.amount": "Auszahlungsbetrag",
  "withdraw.emailCode": "E-Mail-Code",
  "withdraw.emailCodePlaceholder": "E-Mail-Verifizierungscode eingeben",
  "withdraw.resend": "Erneut in {count}s",
  "withdraw.sendCode": "Code senden",
  "withdraw.expectedArrival": "Voraussichtliche Ankunft",
  "withdraw.networkFee": "Netzwerkgebühr",
  "withdraw.actualArrival": "Tatsächliche Ankunft",
  "withdraw.submitting": "⏳ Wird gesendet...",
  "withdraw.confirm": "🚀 Auszahlung bestätigen",
  "withdraw.selectFirst": "👆 Bitte Münze und Netzwerk auswählen",
  "withdraw.minAmount": "Mindestauszahlung",
  "withdraw.maxAmount": "Maximale Auszahlung",
  "withdraw.all": "Alle",
  "withdraw.available": "Verfügbar",
  "withdraw.insufficientBalance": "Unzureichendes Guthaben",
  "withdraw.enterAmount": "Bitte Auszahlungsbetrag eingeben",
  "withdraw.enterCode": "Bitte E-Mail-Verifizierungscode eingeben",
  "withdraw.selectAddressFirst": "Bitte eine Auszahlungsadresse auswählen",
  "withdraw.success": "Auszahlungsantrag eingereicht",
  "withdraw.fail": "Auszahlung fehlgeschlagen",
  "withdraw.arrivalTime": "10-30 Minuten",
  "withdraw.noticeTitle": "📋 Auszahlungshinweise",
  "withdraw.notice1Title": "Ankunftszeit",
  "withdraw.notice1Desc":
    "Kryptowährungs-Auszahlungen kommen in der Regel in 10-30 Minuten an, abhängig von der Bestätigungsgeschwindigkeit des Blockchain-Netzwerks.",
  "withdraw.notice2Title": "Mindestauszahlung",
  "withdraw.notice2Desc":
    "Der Mindestauszahlungsbetrag beträgt 0,001 BTC oder den Gegenwert in anderen Münzen. Beträge darunter können nicht eingereicht werden.",
  "withdraw.notice3Title": "Adressverifizierung",
  "withdraw.notice3Desc":
    "Bitte überprüfen Sie die Auszahlungsadresse sorgfältig. Falsche Operationen können zu dauerhaftem Vermögensverlust führen. Die Plattform ist nicht verantwortlich.",
  "withdraw.notice4Title": "Gebührenerklärung",
  "withdraw.notice4Desc":
    "Auszahlungsgebühren werden vom Blockchain-Netzwerk bestimmt. Die Plattform erhebt keine zusätzlichen Gebühren. Gebühren werden vom Auszahlungsbetrag abgezogen.",
  "withdraw.codeError": "Verifizierungscode-Fehler",
  "withdraw.twoFactorDesc":
    "Geben Sie Ihren 2FA-Code ein, um den E-Mail-Verifizierungscode zu senden",
  "withdraw.selectBank": "Bankkonto auswählen",
  "withdraw.selectBankPlaceholder": "Bankkonto auswählen",
  "withdraw.bankBOC": "Bank of China",
  "withdraw.bankICBC": "ICBC",
  "withdraw.addBank": "+ Neues Konto hinzufügen",
  "withdraw.bankAmount": "Auszahlungsbetrag (USD)",
  "withdraw.exchangeRate": "💱 Wechselkurs",
  "withdraw.arrivalTimeLabel": "⏱️ Ankunftszeit",
  "withdraw.bankArrivalTime": "1-3 Werktage",
  "withdraw.bankConfirm": "🏦 Auszahlung bestätigen",
  "withdraw.bankSuccess":
    "🏦 Bank-Auszahlungsantrag eingereicht. Ankunft innerhalb von 1-3 Werktagen",

  // ===== Einzahlungsseite =====
  "depositPage.title": "💰 Konto-Einzahlung",
  "depositPage.desc": "Wählen Sie eine Einzahlungsmethode für schnelle Ankunft",
  "depositPage.balance": "Aktuelles Guthaben",
  "depositPage.methodCrypto": "🪙 Kryptowährung",
  "depositPage.methodOnline": "💳 Online-Einzahlung",
  "depositPage.coin": "Münze",
  "depositPage.protocol": "Protokoll",
  "depositPage.qrAlt": "Einzahlungs-QR-Code",
  "depositPage.qrPlaceholder": "Kein QR-Code verfügbar",
  "depositPage.copy": "📋 Kopieren",
  "depositPage.copied": "✅",
  "depositPage.addressWarning":
    "⚠️ Unterstützt nur <strong>{coin}</strong> ({protocol}) Überweisungen. Senden Sie keine anderen Vermögenswerte",
  "depositPage.amountPlaceholder": "Einzahlungsbetrag eingeben (optional)",
  "depositPage.transferBtn": "🚀 Ich habe überwiesen",
  "depositPage.emptyState": "👆 Bitte Münze und Protokoll auswählen",
  "depositPage.noticeTitle": "📋 Einzahlungshinweise",
  "depositPage.onlineCardName1": "Kredit-/Debitkarte",
  "depositPage.onlineCardDesc1": "Visa · Mastercard",
  "depositPage.onlineCardBtn1": "Bezahlen →",
  "depositPage.onlineCardName2": "Banküberweisung",
  "depositPage.onlineCardDesc2": "Ankunft in 1-3 Werktagen",
  "depositPage.onlineCardBtn2": "Info erhalten →",
  "depositPage.onlineCardName3": "Drittanbieter-Zahlung",
  "depositPage.onlineCardDesc3": "Alipay · WeChat · Paypal",
  "depositPage.onlineCardBtn3": "Bezahlen →",
  "depositPage.notice1Title": "Ankunftszeit",
  "depositPage.notice1Desc":
    "Kryptowährungs-Einzahlungen erfordern eine Bestätigung durch das Blockchain-Netzwerk, in der Regel 10-30 Minuten, abhängig von der Netzwerkauslastung.",
  "depositPage.notice2Title": "Mindesteinzahlung",
  "depositPage.notice2Desc":
    "Der Mindesteinzahlungsbetrag beträgt 0,001 BTC oder den Gegenwert in anderen Münzen. Beträge darunter können nicht gutgeschrieben werden.",
  "depositPage.notice3Title": "Bestätigungsanforderungen",
  "depositPage.notice3Desc":
    "BTC erfordert 3 Netzwerkbestätigungen. ETH/TRX/USDT erfordert 12 Bestätigungen, bevor es Ihrem Kontoguthaben gutgeschrieben wird.",
  "depositPage.notice4Title": "Erinnerung zur Vermögenssicherheit",
  "depositPage.notice4Desc":
    "Bitte überprüfen Sie sorgfältig die Einzahlungsadresse und den Protokolltyp. Falsche Operationen können zu dauerhaftem Vermögensverlust führen. Die Plattform ist nicht verantwortlich.",
  "depositPage.feeInfo": "💸 Gebühr: {fee}",

  // ===== Wallet-Adresse binden =====
  "bindAddress.title": "🔗 Wallet-Adresse binden",
  "bindAddress.desc":
    "Binden Sie Ihre Kryptowährungs-Wallet-Adresse für Auszahlungen",
  "bindAddress.cardTitle": "➕ Neues Wallet binden",
  "bindAddress.selectCoin": "Münze auswählen",
  "bindAddress.selectProtocol": "Protokoll auswählen",
  "bindAddress.walletAddress": "Wallet-Adresse",
  "bindAddress.walletAddressPlaceholder": "Wallet-Adresse eingeben",
  "bindAddress.emailCode": "E-Mail-Code",
  "bindAddress.emailCodePlaceholder": "E-Mail-Verifizierungscode eingeben",
  "bindAddress.resend": "Erneut in {count}s",
  "bindAddress.sendCode": "Code senden",
  "bindAddress.confirmBind": "🔗 Bindung bestätigen",
  "bindAddress.noticeTitle": "📋 Bindungshinweise",
  "bindAddress.twoFactorDesc":
    "Geben Sie Ihren 2FA-Code ein, um den E-Mail-Verifizierungscode zu senden",
  "bindAddress.notice1Title": "Vermögenssicherheit",
  "bindAddress.notice1Desc":
    "Bitte stellen Sie sicher, dass die von Ihnen gebundene Wallet-Adresse Ihnen gehört und Sie den privaten Schlüssel sicher aufbewahren.",
  "bindAddress.notice2Title": "Auszahlungsbeschränkung",
  "bindAddress.notice2Desc":
    "Innerhalb von 24 Stunden nach der Bindung sind keine Auszahlungen erlaubt, um die Sicherheit der Kontovermögenswerte zu schützen.",
  "bindAddress.notice3Title": "E-Mail-Verifizierung",
  "bindAddress.notice3Desc":
    "Jede neue Wallet-Bindung erfordert eine Bestätigung per E-Mail-Verifizierungscode.",
  "bindAddress.notice4Title": "Adressverifizierung",
  "bindAddress.notice4Desc":
    "Bitte überprüfen Sie die Wallet-Adresse sorgfältig. Falsche Bindung kann dazu führen, dass Vermögenswerte nicht wiederhergestellt werden können.",
  "bindAddress.msgAddressInvalid":
    "⚠️ Bitte geben Sie zuerst eine gültige Wallet-Adresse ein",
  "bindAddress.msgCodeError": "Verifizierungscode-Fehler",
  "bindAddress.msgFormInvalid":
    "Bitte füllen Sie alle Informationen aus und erhalten Sie den E-Mail-Verifizierungscode",

  // ===== Fehlerseite =====
  "error.backHome": "Zurück zur Startseite",
  "error.refresh": "Aktualisieren",
  "error.footerTip":
    "Wenn das Problem weiterhin besteht, kontaktieren Sie bitte den technischen Support",
  "error.title404": "Seite nicht gefunden",
  "error.desc404": "Die gesuchte Seite existiert nicht oder wurde entfernt",

  phase: "Phase",

  // de-de 德语
  country: {
    1: "Vereinigte Staaten",
    2: "China",
    3: "Japan",
    4: "Südkorea",
    5: "Deutschland",
    6: "Vereinigtes Königreich",
    7: "Frankreich",
    8: "Vereinigte Arabische Emirate",
    9: "Singapur",
    10: "Israel",
    11: "Russland",
    12: "Indien",
    13: "Brasilien",
    14: "Italien",
    15: "Spanien",
    16: "Portugal",
    17: "Niederlande",
    18: "Belgien",
    19: "Schweiz",
    20: "Schweden",
    21: "Norwegen",
    22: "Finnland",
    23: "Dänemark",
    24: "Island",
    25: "Irland",
    26: "Österreich",
    27: "Polen",
    28: "Tschechien",
    29: "Ungarn",
    30: "Griechenland",
    31: "Ukraine",
    32: "Weißrussland",
    33: "Rumänien",
    34: "Bulgarien",
    35: "Serbien",
    36: "Kroatien",
    37: "Albanien",
    38: "Estland",
    39: "Lettland",
    40: "Litauen",
    41: "Moldawien",
    42: "Slowakei",
    43: "Slowenien",
    44: "Bosnien und Herzegowina",
    45: "Montenegro",
    46: "Nordmazedonien",
    47: "Luxemburg",
    48: "Malta",
    49: "Andorra",
    50: "Monaco",
    51: "Liechtenstein",
    52: "San Marino",
    53: "Vatikanstadt",
    54: "Kanada",
    55: "Mexiko",
    56: "Kuba",
    57: "Guatemala",
    58: "Honduras",
    59: "Nicaragua",
    60: "Costa Rica",
    61: "Panama",
    62: "Jamaika",
    63: "Haiti",
    64: "Dominikanische Republik",
    65: "Trinidad und Tobago",
    66: "Dominica",
    67: "St. Lucia",
    68: "St. Vincent und die Grenadinen",
    69: "Grenada",
    70: "St. Kitts und Nevis",
    71: "Antigua und Barbuda",
    72: "Bahamas",
    73: "Barbados",
    74: "Belize",
    75: "El Salvador",
    76: "Argentinien",
    77: "Kolumbien",
    78: "Venezuela",
    79: "Peru",
    80: "Chile",
    81: "Ecuador",
    82: "Bolivien",
    83: "Paraguay",
    84: "Uruguay",
    85: "Guyana",
    86: "Suriname",
    87: "Australien",
    88: "Neuseeland",
    89: "Papua-Neuguinea",
    90: "Fidschi",
    91: "Salomonen",
    92: "Vanuatu",
    93: "Samoa",
    94: "Kiribati",
    95: "Mikronesien",
    96: "Marshallinseln",
    97: "Palau",
    98: "Nauru",
    99: "Tuvalu",
    100: "Tonga",
    101: "Cookinseln",
    102: "Niue",
    103: "Ägypten",
    104: "Südafrika",
    105: "Nigeria",
    106: "Äthiopien",
    107: "Kenia",
    108: "Tansania",
    109: "Algerien",
    110: "Marokko",
    111: "Sudan",
    112: "Südsudan",
    113: "Ghana",
    114: "Angola",
    115: "Mosambik",
    116: "Madagaskar",
    117: "Kamerun",
    118: "Elfenbeinküste",
    119: "Niger",
    120: "Burkina Faso",
    121: "Mali",
    122: "Senegal",
    123: "Uganda",
    124: "Sambia",
    125: "Simbabwe",
    126: "Tschad",
    127: "Kongo",
    128: "Demokratische Republik Kongo",
    129: "Gabun",
    130: "Botswana",
    131: "Namibia",
    132: "Mauritius",
    133: "Ruanda",
    134: "Somalia",
    135: "Dschibuti",
    136: "Eritrea",
    137: "Libyen",
    138: "Tunesien",
    139: "Sierra Leone",
    140: "Liberia",
    141: "Togo",
    142: "Benin",
    143: "Guinea",
    144: "Guinea-Bissau",
    145: "Gambia",
    146: "Kap Verde",
    147: "São Tomé und Príncipe",
    148: "Äquatorialguinea",
    149: "Mauretanien",
    150: "Eswatini",
    151: "Lesotho",
    152: "Malawi",
    153: "Zentralafrikanische Republik",
    154: "Burundi",
    155: "Komoren",
    156: "Seychellen",
    157: "Türkei",
    158: "Iran",
    159: "Irak",
    160: "Saudi-Arabien",
    161: "Mongolei",
    162: "Nordkorea",
    163: "Indonesien",
    164: "Philippinen",
    165: "Vietnam",
    166: "Thailand",
    167: "Malaysia",
    168: "Myanmar",
    169: "Kambodscha",
    170: "Laos",
    171: "Brunei",
    172: "Osttimor",
    173: "Pakistan",
    174: "Bangladesch",
    175: "Nepal",
    176: "Bhutan",
    177: "Sri Lanka",
    178: "Malediven",
    179: "Kasachstan",
    180: "Usbekistan",
    181: "Turkmenistan",
    182: "Kirgisistan",
    183: "Tadschikistan",
    184: "Afghanistan",
    185: "Syrien",
    186: "Jordanien",
    187: "Libanon",
    188: "Palästina",
    189: "Oman",
    190: "Jemen",
    191: "Kuwait",
    192: "Katar",
    193: "Bahrain",
    194: "Georgien",
    195: "Armenien",
    196: "Aserbaidschan",
    197: "Zypern",
  },

  token: {
    us: {
      content: {
        title: "",
        content: usContent.content,
      },
      t1: {
        title: "Aktueller Status",
        content: usContent.t1,
      },
      t2: {
        title: "Kernvorteile",
        content: usContent.t2,
      },
      t3: {
        title: "Herausforderungen",
        content: usContent.t3,
      },
      t4: {
        title: "Zukunftstrends",
        content: usContent.t4,
      },
    },
    cn: {
      content: {
        title: "",
        content: cnContent.content,
      },
      t1: {
        title: "Aktueller Status",
        content: cnContent.t1,
      },
      t2: {
        title: "Kernvorteile",
        content: cnContent.t2,
      },
      t3: {
        title: "Herausforderungen",
        content: cnContent.t3,
      },
      t4: {
        title: "Zukunftstrends",
        content: cnContent.t4,
      },
    },
    jp: {
      content: {
        title: "",
        content: jpContent.content,
      },
      t1: {
        title: "Aktueller Status",
        content: jpContent.t1,
      },
      t2: {
        title: "Kernvorteile",
        content: jpContent.t2,
      },
      t3: {
        title: "Herausforderungen",
        content: jpContent.t3,
      },
      t4: {
        title: "Zukunftstrends",
        content: jpContent.t4,
      },
    },
    ko: {
      content: {
        title: "",
        content: koContent.content,
      },
      t1: {
        title: "Aktueller Status",
        content: koContent.t1,
      },
      t2: {
        title: "Kernvorteile",
        content: koContent.t2,
      },
      t3: {
        title: "Herausforderungen",
        content: koContent.t3,
      },
      t4: {
        title: "Zukunftstrends",
        content: koContent.t4,
      },
    },
    ge: {
      content: {
        title: "",
        content: geContent.content,
      },
      t1: {
        title: "Aktueller Status",
        content: geContent.t1,
      },
      t2: {
        title: "Kernvorteile",
        content: geContent.t2,
      },
      t3: {
        title: "Herausforderungen",
        content: geContent.t3,
      },
      t4: {
        title: "Zukunftstrends",
        content: geContent.t4,
      },
    },
    uk: {
      content: {
        title: "",
        content: ukContent.content,
      },
      t1: {
        title: "Aktueller Status",
        content: ukContent.t1,
      },
      t2: {
        title: "Kernvorteile",
        content: ukContent.t2,
      },
      t3: {
        title: "Herausforderungen",
        content: ukContent.t3,
      },
      t4: {
        title: "Zukunftstrends",
        content: ukContent.t4,
      },
    },
    fr: {
      content: {
        title: "",
        content: frContent.content,
      },
      t1: {
        title: "Aktueller Status",
        content: frContent.t1,
      },
      t2: {
        title: "Kernvorteile",
        content: frContent.t2,
      },
      t3: {
        title: "Herausforderungen",
        content: frContent.t3,
      },
      t4: {
        title: "Zukunftstrends",
        content: frContent.t4,
      },
    },
    uae: {
      content: {
        title: "",
        content: uaeContent.content,
      },
      t1: {
        title: "Aktueller Status",
        content: uaeContent.t1,
      },
      t2: {
        title: "Kernvorteile",
        content: uaeContent.t2,
      },
      t3: {
        title: "Herausforderungen",
        content: uaeContent.t3,
      },
      t4: {
        title: "Zukunftstrends",
        content: uaeContent.t4,
      },
    },
    sg: {
      content: {
        title: "",
        content: sgContent.content,
      },
      t1: {
        title: "Aktueller Status",
        content: sgContent.t1,
      },
      t2: {
        title: "Kernvorteile",
        content: sgContent.t2,
      },
      t3: {
        title: "Herausforderungen",
        content: sgContent.t3,
      },
      t4: {
        title: "Zukunftstrends",
        content: sgContent.t4,
      },
    },
  },

  // ===== Startseite - Zusätzlich =====
  "home.altQr": "Zum Herunterladen scannen",
  "home.altApp": "App-Screenshot",
  "home.altWallet": "Wallet-Symbol",

  // ===== Mietdetailseite =====
  "detail.breadcrumbHome": "Startseite",
  "detail.breadcrumbRental": "Serververmietung",
  "detail.breadcrumbDetail": "Details",
  "detail.badgeHot": "🔥 Heiße Empfehlung",
  "detail.badgeAvailable": "✅ Verfügbar",
  "detail.badgeSold": "⏳ Voll vermietet",
  "detail.badgeEnded": "⏳ Beendet",
  "detail.badgePending": "⏳ Nicht gestartet",
  "detail.code": "Code: ",
  "detail.specTitle": "Vollständige Spezifikationen",
  "detail.specGpu": "GPU-Modell",
  "detail.specVram": "VRAM",
  "detail.specStorage": "Speicher",
  "detail.specRam": "Arbeitsspeicher",
  "detail.specBandwidth": "Bandbreite",
  "detail.specValue": "Serverwert",
  "detail.specCountry": "Land",
  "detail.specCountryFlag": "Landesflagge",
  "detail.specStatus": "Status",
  "detail.statusFull": "⏳ Voll",
  "detail.statusEnded": "⏳ Beendet",
  "detail.statusPending": "⏳ Nicht gestartet",
  "detail.statusAvailable": "✅ Verfügbar",
  "detail.chartTitle": "Einkommenstrend",
  "detail.chartRealTime": "Echtzeit",
  "detail.chartHint": "Zum Vergrößern klicken",
  "detail.chart7d": "7T",
  "detail.chart15d": "15T",
  "detail.chart30d": "30T",
  "detail.statMax": "Max",
  "detail.statAvg": "Durchschnitt",
  "detail.statMin": "Min",
  "detail.statChange": "Änderung",
  "detail.descTitle": "Produktbeschreibung",
  "detail.regionTitle": "Regionsinfo",
  "detail.panelTitle": "💎 Jetzt mieten",
  "detail.statusDotFull": "● Voll",
  "detail.statusDotEnded": "● Beendet",
  "detail.statusDotPending": "● Nicht gestartet",
  "detail.statusDotAvailable": "● Verfügbar",
  "detail.activityPeriod": "📅 Zykluszeit",
  "detail.daysLeft": "übrig",
  "detail.days": "Tagen",
  "detail.subscribeShare": "🎚️ Anteil abonnieren",
  "detail.customShare": "Benutzerdefinierter Anteil",
  "detail.remainingShare": "Verbleibender Anteil",
  "detail.shareMsg":
    "Der Abonnementanteil darf den verbleibenden {n}% Rechenleistungswert nicht überschreiten",
  "detail.incomeDetail": "📈 Geschätzte Einkommensdetails",
  "detail.incomeTip":
    "Geschätztes Einkommen dient nur als Referenz. Tatsächliches Einkommen basiert auf Abrechnungsdaten",
  "detail.estimate": "Schätzung",
  "detail.rate": "Rendite:",
  "detail.settleDate": "Abrechnungsdatum:",
  "detail.moreStages": "{count} weitere Phasen",
  "detail.hoverExpand": "Zum Erweitern schweben",
  "detail.totalIncome": "Geschätztes Gesamteinkommen",
  "detail.fundDetail": "💰 Fonddetails",
  "detail.rentalAmount": "Mietbetrag",
  "detail.maintenanceFee": "Wartungsgebühr",
  "detail.feeFormula": "Gesamtwert*{percent}%*{fee}%",
  "detail.tierDiscount": "Stufenrabatt",
  "detail.subscribeTip": "(Anteil {percent}%)",
  "detail.discountDetail": "🎯 Rabattstufen-Details",
  "detail.subscribeGte": "Anteil ≥ {percent}%",
  "detail.currentSubscribe": "Aktueller Anteil {percent}%, Rabatt -${discount}",
  "detail.total": "Gesamt",
  "detail.btnFull": "⏳ Voll",
  "detail.btnEnded": "⏳ Beendet",
  "detail.btnPending": "⏳ Nicht gestartet",
  "detail.btnRent": "🚀 Jetzt mieten",
  "detail.btnOutOfStock": "⏳ Vorübergehend ausverkauft",
  "detail.guaranteeSupport": "7×24 Kundensupport",
  "detail.guaranteeData": "Datensicherheit",
  "detail.guaranteeSla": "99,9% SLA",
  "detail.recommendBadge": "🔄 Das könnte Ihnen auch gefallen",
  "detail.recommendTitle1": "Empfohlen",
  "detail.recommendTitle2": "Server",
  "detail.recValue": "Wert",
  "detail.recDetail": "Details ansehen →",
  "detail.faqBadge": "❓ FAQ",
  "detail.faqTitle1": "Miete",
  "detail.faqTitle2": "FAQ",
  "detail.chartModalTitle": "📈 Einkommenstrend-Diagramm",
  "detail.spec0": "Einstieg",
  "detail.spec1": "Leicht",
  "detail.spec2": "Leistung",
  "detail.spec3": "Flaggschiff",
  "detail.spec4": "Ultra-Flaggschiff",
  "detail.faq1Q": "Benötige ich eine Kaution, um einen Server zu mieten?",
  "detail.faq1A":
    "Für Erstnutzer können wir einen bestimmten Prozentsatz als Kaution verlangen. Langzeitpartner können Rabatte auf die Kaution erhalten. Der konkrete Betrag basiert auf der Abrechnungsseite.",
  "detail.faq2Q": "Wie verlängere ich nach Ablauf der Miete?",
  "detail.faq2A":
    "Sie können auf der Seite 'Meine Mieten' in der Konsole verlängern. Unterstützt tägliche, wöchentliche, monatliche und vierteljährliche Verlängerung zum gleichen Preis wie die aktuelle Miete.",
  "detail.faq3Q": "Was passiert, wenn der Server eine Störung hat?",
  "detail.faq3A":
    "Wir bieten 7×24 technischen Support. Bei Hardwarefehlern reagieren wir innerhalb von 2 Stunden und schließen Reparatur oder Austausch innerhalb von 24 Stunden ab.",
  "detail.faq4Q": "Kann ich die Miete vorzeitig beenden?",
  "detail.faq4A":
    "Ja. Bei vorzeitiger Beendigung ist eine Strafe von 30% der verbleibenden Mietdauer zu zahlen. Bitte lesen Sie die 'Mietservice-Vereinbarung' beim Mieten sorgfältig.",
  "detail.faq5Q":
    "Wie wird die Datensicherheit für gemietete Server gewährleistet?",
  "detail.faq5A":
    "Wir verwenden Unternehmensverschlüsselung. Alle Daten werden während Übertragung und Speicherung verschlüsselt. Nach Ende der Miete werden Ihre Daten vollständig gelöscht.",
  "detail.unitWan": "K",
  "detail.msgOutOfStock": "Dieser Server ist vorübergehend ausverkauft",
  "detail.msgSelectShare": "Bitte wählen Sie einen Abonnementanteil",
  "detail.msgRentFail": "Miete fehlgeschlagen",
  "detail.msgRentSuccess": "Miete erfolgreich",
  "detail.msgContact": "Support kontaktieren: 400-888-8888",
  "detail.pwdTitle": "Mietbestätigung",
  "detail.pwdLabel": "Handelspasswort eingeben",
  "detail.pwdPlaceholder": "Handelspasswort eingeben",
  "detail.pwdConfirm": "Miete bestätigen",
  "detail.pwdCancel": "Abbrechen",
  "detail.rentNow": "💎 Jetzt mieten",
  "detail.rentAmount": "Mietbetrag",
  "detail.subscribe": "Abonnieren",
  "detail.descProduct": "Produktbeschreibung",
  "detail.descRegion": "Regionsinformationen",
  "detail.rentNowBtn": "🚀 Jetzt mieten",
  "detail.outOfStock": "⏳ Vorübergehend ausverkauft",
  "detail.stages": "Stufen",
  "detail.discount": "Rabatt",
  "detail.rentConfirm": "Miete bestätigen",
  "detail.enterPassword": "Bitte Transaktionspasswort eingeben",
  "detail.confirmRent": "Miete bestätigen",
  "detail.cancel": "Abbrechen",
  "detail.rentyunxz": "In Betrieb",
  "detail.outOfStockMsg": "Dieser Server ist vorübergehend ausverkauft",
  "detail.selectShareMsg": "Bitte Anteil auswählen",
  "detail.rentFail": "Miete fehlgeschlagen",
  "detail.rentSuccess": "Miete erfolgreich",
  "detail.contactService": "Kontaktieren Sie den Support: 400-888-8888",
  "detail.tenThousand": "K",

  // ===== Rechenleistungs-Informationsseite =====
  "info.emptyTitle": "Keine Rechenleistungsserver verfügbar",
  "info.emptyDesc":
    "Bald verfügbar. Wir arbeiten hart daran, mehr hochwertige Rechenleistungsressourcen für Sie vorzubereiten",
  "info.collapse": "Einklappen",
  "info.expand": "Erweitern",
  "info.collapseDetail": "Details einklappen",
  "info.expandDetail": "Details erweitern",
  "info.priceTrend": "📈 Preistrend",
  "info.docsTitle": "📄 Produktdokumente",
  "info.unit": "Einheit",
  "info.latestPrice": "Aktueller Preis",
  "info.lastPrice": "Preis von gestern",
  "info.increase": "Anstieg",
  "info.buyNow": "Jetzt kaufen",
  "info.buyCompute": "Rechenleistung kaufen",
  "info.selectPeriod": "Zeitraum auswählen",
  "info.day": "Tagen",
  "info.periodTime": "Zeitraum",
  "info.purchaseQuantity": "Kaufmenge",
  "info.expectedProfit": "Geschätztes Einkommen",
  "info.profitTip":
    "Geschätztes Einkommen basiert auf historischen Durchschnittswerten. Tatsächliches Einkommen basiert auf Abrechnungsdaten",
  "info.baseProfit": "Grundeinkommen",
  "info.settle24h": "24h-Abrechnung",
  "info.periodProfit": "Zeitraumeinkommen",
  "info.settleDue": "Fällige Abrechnung",
  "info.totalProfit": "Gesamteinkommen",
  "info.fundDetail": "Fonddetails",
  "info.purchaseAmount": "Kaufbetrag",
  "info.buyFormula": "Aktueller Preis x Menge",
  "info.fee": "Gebühr",
  "info.feeFormula": "Kaufbetrag*{fee}%",
  "info.total": "Gesamt",
  "info.cancel": "Abbrechen",
  "info.confirmBuy": "Kauf bestätigen",
  "info.tradeConfirm": "Handelsbestätigung",
  "info.enterPassword": "Handelspasswort eingeben",
  "info.confirmPay": "Zahlung bestätigen",
  "info.chart7d": "7T",
  "info.chart15d": "15T",
  "info.chart30d": "30T",
  "info.price": "Preis",
  "info.maxValue": "Maximalwert",
  "info.noData": "Keine Daten",
  "info.fetchFail": "Datenabruf fehlgeschlagen",
  "info.selectProduct": "Bitte wählen Sie zuerst ein Produkt",
  "info.quantityMin": "Kaufmenge darf nicht kleiner als 1 sein",
  "info.priceError":
    "Aktueller Preis ist abnormal, bitte später erneut versuchen",
  "info.buySuccess": "Kauf erfolgreich!",
  "info.tradeFail": "Transaktion fehlgeschlagen, bitte später erneut versuchen",
  "info.passwordError": "Handelspasswort falsch, bitte erneut eingeben",
  "info.buyFail": "Kauf fehlgeschlagen, bitte später erneut versuchen",

  // ===== Über-uns-Seite =====
  "about.tocTitle": "📑 Inhaltsverzeichnis",
  "about.toc1": "Digitales Gold meistern",
  "about.toc2": "Kernprodukt-Matrix",
  "about.toc3": "Aetrivol Sicherheit & Zuverlässigkeit",
  "about.toc4": "Investitionswert",
  "about.section1Title":
    "Digitales Gold meistern: Werden Sie der 'Super Neue Rechenleistungs-Lord' des intelligenten Zeitalters",
  "about.section1P1":
    "Während globale Modelle in Billionen-Parameter-Schlachten eintreten und verkörperte Intelligenz vollständig explodiert, hat Rechenleistung Öl vollständig als ultimative harte Währung ersetzt, die den Weltreichtum dominiert. Tech-Giganten horten GPUs um jeden Preis, und Rechenzentren, die Hunderte Millionen kosten, schließen normale Investoren aus. Aetrivol wurde geboren, um den Anforderungen der Zeit gerecht zu werden. Durch unseren innovativen Rechenleistungs-Ankermechanismus und das Rechenleistungs-Server-Mietmodell brechen wir Vermögensmonopole und lassen Sie auf einfachste und flexibelste Weise direkt am größten Vermögensvermehrungsfest der Menschheitsgeschichte teilhaben.",
  "about.section2Title": "Kernprodukt-Matrix: Dual-Antriebs-Vermögensmotor",
  "about.section2H1":
    "Innovatives Produkt 1: [Rechenleistungswert (CV)] — 'Tokenisierte Dividenden' globaler Rechenleistungs-Assets",
  "about.section2P1":
    "· Barrieren brechen, Mikro-Assetisierung: Wir standardisieren und teilen die Gesamtrechenleistung globaler physischer Rechenzentren und High-End-GPU-Server (NVIDIA Blackwell, Huawei Ascend usw.). 1 Punkt [Rechenleistungswert] repräsentiert Ihr Eigentum an einem bestimmten Anteil der Rechenleistung im globalen Rechennetzwerk.",
  "about.section2P2":
    "· GPU kaufen wie einen Fonds: Mit einer minimalen kleinen Investition zur Zeichnung von [Rechenleistungswert] können Sie die Barriere 'schwer eine Karte zu bekommen' durchbrechen. Ihr Rechenleistungswert läuft 24/7 auf der Plattform und erzielt täglich digitale Cashflow-Dividenden aus KI-Großmodellen und Agent-Aufrufen weltweit.",
  "about.section2P3":
    "· Hohe Liquidität, jederzeit auszahlen: Rechenleistungswert hat extrem starke Vermögensliquidität. Mit steigender globaler Rechenleistungsnachfrage hat Rechenleistungswert selbst hohes Aufwertungspotenzial. Sie können jederzeit auf der Plattform handeln und auszahlen.",
  "about.section2H2":
    "Kerngeschäft 2: [Rechenleistungs-Server-Leasing] — Das stabile langfristige 'Digital-Vermieter'-Modell",
  "about.section2P4":
    "· Physische Asset-Zeichnung, exklusives Server-Eigentum: Investoren können direkt ganze Server oder Standard-Racks von Rechenleistungsservern unter der Plattform zeichnen. Jeder Server ist on-chain mit einer eindeutigen physischen SN-Nummer abgebildet.",
  "about.section2P5":
    "· Langfristiges verwaltetes Leasing, stabile hohe Miete: Nach der Zeichnung werden Server direkt in den Top-Rechenzentren der Plattform an globalen grünen Rechenleistungs-Hubs (wie Chinas West-Ost-Daten-West-Computing-Knoten, Nordeuropa, Naher Osten usw.) gehostet. Die Plattform vermietet Ihre Server an Großmodell-Entwickler, Universitätsforschungsinstitute oder vertikale KI-Unternehmen, die Rechenleistung benötigen, und sichert 3-5 Jahre stabile hohe Renditen.",
  "about.section3Title":
    "Warum kann Aetrivol Risiko in absolute Sicherheit verwandeln?",
  "about.section3P1":
    "· 100% physische Asset-On-Chain-Verankerung: Wir lehnen Luftschlösser ab. Ob der Rechenleistungswert, den Sie halten, oder die Server, die Sie mieten, sie werden alle in Echtzeit on-chain auf physische Beschleuniger-Hardware abgebildet, die online ist und summt. Vermögenswerte sind sichtbar, greifbar und verifizierbar.",
  "about.section3P2":
    "· Top-Energieeffizienz und 'Anti-Geopolitik'-Doppelversicherung: Die von uns verpackten Rechenzentren sind zu 100% mit 'Mikro-Nuklear (SMR)/Solar-Direktstromversorgung' ausgestattet oder befinden sich in absolut sicheren Nicht-Konflikt-Rechtsgebieten, wodurch die Risiken globaler lokaler Netz-Tsunamis und geopolitischer Schwankungen vollständig vermieden werden.",
  "about.section3P3":
    "· Giganten-Kredit-Endorsement und Langzeitvertrags-Garantie: Die Plattform priorisiert ausgereifte Standorte, die von KI-Giganten wie Microsoft, OpenAI und DeepSeek vorab für Leasing gesichert wurden, und nutzt die Kreditwürdigkeit von Tech-Giganten als Endorsement für Ihre Renditen.",
  "about.section4Title":
    "Früher investierten sie in Land und Öl; heute investieren wir in Rechenleistung.",
  "about.section4P1":
    "Während alle menschliche Weisheit und Geschäfte in die digitale Welt migrieren, ist Rechenleistung das einzige Baumaterial dieser neuen Welt. Treten Sie Aetrivol bei, kaufen Sie Ihren Rechenleistungswert und starten Sie Ihre Rechenleistungs-Server-Mietreise. Verwandeln Sie Ihr Kapital in Rechenleistungs-Atome, die die Welt neu gestalten, und teilen Sie diesen Vermögensanstieg der intelligenten Explosion!",

  agreement: agreementContent,

  "withdraw.insufficientHandlingFee": "Unzureichende Bearbeitungsgebühr",
  "withdraw.twoFactor":
    "Sie haben die Zwei-Faktor-Authentifizierung noch nicht aktiviert, daher können Sie keine Auszahlung vornehmen. Bitte aktivieren Sie zuerst die Zwei-Faktor-Authentifizierung.",
  "bindAddress.twoFactor":
    "Sie haben die Zwei-Faktor-Authentifizierung noch nicht aktiviert, daher können Sie keine Adresse binden. Bitte aktivieren Sie zuerst die Zwei-Faktor-Authentifizierung.",
  "productServer.statusPending": "Wartet auf Ausführung",
  "historyToken.add": "Einzahlen",
  "serverServer.serverover": "Abrechnungstag",

  "walletLog.statusPeriodIncome": "Periodischer Ertrag",
  "productToken.statusOver": "Beendet",
  "productServer.phaseDate": "Abrechnungsdatum",
};
